import './instrument';
// Startup point for client side application
import React from 'react';

import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import {
    BrowserRouter,
    Switch,
} from 'react-router-dom';

import RouteWithSubRoutes from '@src/components/RoutesWithSubRoutes';
import IEErrorPage from '@src/containers/errors/IEErrorPage';
import { isIE } from '@src/utils/browser-detect';


import { routes } from './routes';
import store from './store';

const root = createRoot(document.querySelector('#root'));

if (isIE) {
    root.render(<IEErrorPage />);
} else {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                retry: false,
            },
        },
    });

    const s = store();

    root.render(
        <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            <QueryClientProvider client={queryClient}>
                <Provider store={s}>
                    <BrowserRouter>
                        <Switch>
                            {
                                routes.map((route) => (
                                    <RouteWithSubRoutes key={route.path} {...route} />
                                ))
                            }
                        </Switch>
                    </BrowserRouter>
                </Provider>
            </QueryClientProvider>
        </Sentry.ErrorBoundary>,
    );
}
